import * as React from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ShareIcon from '@mui/icons-material/Share';
import { TooltipMessageStyles } from './Style'
import { QuestionMark } from '@mui/icons-material';
import { useState } from 'react';
import { useCallback } from 'react';
import { Fab } from '@mui/material'

const actions = [
    { icon: <ShareIcon />, name: 'Share' },
];

const TooltipMessage = (props) => {
    const { tooltip, tooltipOpen, handleTooltip } = props
    const [openDial, setOpenDial] = useState(true)

    // const handleOpen = useCallback(() => {
    //     setOpenDial(true)
    //     setTimeout(() => {
    //         if (openDial)
    //             setOpenDial(false)
    //     }, 5000)
    // }, [openDial])

    return (
        tooltip &&
        <React.Fragment>
            {tooltipOpen &&
                <div className='description-custom-tooltip'>
                    <div className='tooltip-corner'></div>
                    {tooltip}
                </div>}
            <div className='tooltip-fab'>
                <Fab color="light" aria-label="edit" onClick={handleTooltip}>
                    <QuestionMark color="gray" />
                </Fab>
            </div>
        </React.Fragment>


        // <TooltipMessageStyles>
        //     <SpeedDial
        //         onMouseOver={handleOpen}
        //         onClick={() => setOpenDial(!openDial)}
        //         open={true}
        //         ariaLabel="SpeedDial basic example"
        //         icon={
        //             <QuestionMark />
        //         }
        //     >
        //         {actions.map((action) => (
        //             <SpeedDialAction
        //                 key={action.name}
        //                 icon={
        //                     <div>
        //                         <div className='tooltip-corner'></div>
        //                         {message}
        //                     </div>
        //                 }
        //             />
        //         ))}
        //     </SpeedDial>
        // </TooltipMessageStyles>
    );
}

export default TooltipMessage